export default {
	tenantId: "msigvn_uat",
	appId: "admin_portal",

	fileSystem: {
		bucketName: "msigvn-uat"
	}
}
